import axios from "axios";
import { annualCertificateSearch, annualCertificateUpload, annualCertificateValidation } from "../endpoints";

export interface AnnualCertificateParams {
  customerAccountName: string;
  customerAccountNumber: string;
  offSet: string;
}

export const getAnnualCertificateData = async (params: AnnualCertificateParams, token: any) => {
  try {
    console.log("getAnnualCertificateData called with params:", params, "and token:", token);
    const resp = await axios.get(annualCertificateSearch, {
      params: {
        customerAccountName: params.customerAccountName? params.customerAccountName : "",
        customerAccountNumber: params.customerAccountNumber? params.customerAccountNumber : "",
        offSet: params.offSet,
      },
      headers: {
        'Content-Type': 'application/json',
        AuthorizationToken: `Bearer ${token}`
      }
    });

    return resp.data;
   
  } catch (ex) {
    throw ex;
  }
};
 export const validateAnnualCertificate = async (data:any, token: any) => {
  try {
    console.log("validateAnnualCertificate called with params:", data, "and token:", token);
    const resp = await axios.post(annualCertificateValidation, data, {
      headers: {
        'Content-Type': 'application/json',
        AuthorizationToken: `Bearer ${token}`
      }
    });

    return resp.data;
   
  } catch (ex) {
    throw ex;
  }
}
 export const uploadAnnualCertificate = async (data:any, token: any) => {
  try {
    console.log("uploadAnnualCertificate called with params:", data, "and token:", token);
    const resp = await axios.post(annualCertificateUpload, data, {
      headers: {
        'Content-Type': 'application/json',
        AuthorizationToken: `Bearer ${token}`
      }
    });

    return resp.data;
   
  } catch (ex) {
    throw ex;
  }
}